import algolia from "algoliasearch";
import getEnvironment from "../../getEnvironment";

const algoliaClient = algolia("EKEGGUH63H", "6790da914deade8cab2915997c0aab5b");

/**
 * @type {algolia.AlgoliaIndex}
 */
const disruptors = algoliaClient.initIndex(`disruptors_${getEnvironment()}`);

export { disruptors };
